module.exports = __webpack_public_path__ + "img/avatar2.5bb78879.png";